<template>
    <div class="content">
        <canvas id="Radar"></canvas>
    </div>
</template>

<script>
    export default {
        name: "canvasRadar",
        props:['radarData'],
        data(){
            return{
                ctx:{},
                cDom:{},
                mW:0,
                mH:0,
                mCount:0, //边数
                mCenter:0, //中心点
                mRadius:0, //半径(减去的值用于给绘制的文本留空间)
                mAngle:0, //角度
                mColorPolygon:'#B8B8B8', //多边形颜色
                mColorLines:'#B8B8B8', //顶点连线颜色
                mColorText:'#6795f7',
                mp:6,
            }
        },
        mounted() {
            let Those = this;
            let width = $(window).width();
            Those.mW = width * 0.8;
            Those.mH = width * 0.8;
        },
        watch:{
            radarData:function() {
                console.log('canvasRadar-radarData 被更新了');
                this.init();
                this.$forceUpdate();
            }
        },
        methods:{
            init(){
                let Those = this;
                Those.mCount = Those.radarData.length;
                Those.mCenter = Those.mW /2;
                Those.mRadius = Those.mCenter - 40;
                Those.mAngle = Math.PI * 2 / Those.mCount;
                Those.cDom = $('#Radar')[0];
                Those.cDom.height = Those.mH * Those.mp;
                Those.cDom.width = Those.mW * Those.mp;
                Those.cDom.style.width = Those.mW + 'px';
                Those.cDom.style.height = Those.mH + 'px';
                Those.ctx = Those.cDom.getContext('2d');
                Those.ctx.scale(Those.mp,Those.mp);
                Those.drawPolygon(Those.ctx);
                Those.drawLines(Those.ctx);
                Those.drawRegion(Those.ctx);
                Those.drawText(Those.ctx);
                Those.drawCircle(Those.ctx);
                Those.drawLines1(Those.ctx);
            },
            // 绘制多边形边
            drawPolygon(){
                let Those = this;
                Those.ctx.save();
                Those.ctx.strokeStyle = Those.mColorPolygon;
                let r = Those.mRadius/ Those.mCount; //单位半径
                //画5个圈
                for(let i = 0; i < Those.mCount; i ++){
                    Those.ctx.beginPath();
                    let currR = r * ( i + 1); //当前半径
                    //画5条边
                    for(let j = 0; j < Those.mCount; j ++){
                        let x = Those.mCenter + currR * Math.cos(Those.mAngle * j);
                        let y = Those.mCenter + currR * Math.sin(Those.mAngle * j);
                        Those.ctx.lineTo(x, y);
                    }
                    Those.ctx.closePath();
                    Those.ctx.stroke();
                }
                Those.ctx.restore();
            },
            //顶点连线
            drawLines(){
                let Those = this;
                Those.ctx.save();
                Those.ctx.beginPath();
                Those.ctx.strokeStyle = Those.mColorLines;
                for(let i = 0; i < Those.mCount; i ++){
                    let x = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * i);
                    let y = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * i);
                    Those.ctx.moveTo(Those.mCenter, Those.mCenter);
                    Those.ctx.lineTo(x, y);
                }
                Those.ctx.stroke();
                Those.ctx.restore();
            },
            //数据点之间的连线
            drawLines1(){
                let Those = this;
                Those.ctx.save();
                Those.ctx.beginPath();
                let count = 0;
                for(let i = 0; i < Those.mCount; i ++){
                    let x = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * i) * Those.radarData[i][1] / 100;
                    let y = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * i) * Those.radarData[i][1] / 100;
                    let x1 = 0;
                    let y1 = 0;
                    count = i + 1;
                    if (count < Those.mCount) {
                        x1 = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * (i+1)) * Those.radarData[i+1][1] / 100;
                        y1 = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * (i+1)) * Those.radarData[i+1][1] / 100;
                    }else{
                        x1 = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * 0) * Those.radarData[0][1] / 100;
                        y1 = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * 0) * Those.radarData[0][1] / 100;
                    }
                    Those.ctx.moveTo(x, y);
                    Those.ctx.lineTo(x1, y1);
                    Those.ctx.lineWidth = 2;          //设置线宽状态
                    Those.ctx.strokeStyle = '#6795f7';  //设置线的颜色状态
                }
                Those.ctx.stroke();
                Those.ctx.restore();
            },

            //绘制文本
            drawText(){
                let Those = this;
                Those.ctx.save();
                let fontSize = Those.mCenter / 12;
                Those.ctx.font ='bolder ' + fontSize + 'px 微软雅黑';
                Those.ctx.fillStyle = Those.mColorText;

                for(let i = 0; i < Those.mCount; i ++){
                    let x = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * i);
                    let y = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * i) ;

                    if( Those.mAngle * i >= 0 && Those.mAngle * i <= Math.PI / 2 ){
                        Those.ctx.fillText(Those.radarData[i][0], x, y + fontSize);
                    }else if(Those.mAngle * i > Math.PI / 2 && Those.mAngle * i <= Math.PI){
                        Those.ctx.fillText(Those.radarData[i][0], x - Those.ctx.measureText(Those.radarData[i][0]).width, y + fontSize);
                    }else if(Those.mAngle * i > Math.PI && Those.mAngle * i <= Math.PI * 3 / 2){
                        Those.ctx.fillText(Those.radarData[i][0], x - Those.ctx.measureText(Those.radarData[i][0]).width, y);
                    }else{
                        Those.ctx.fillText(Those.radarData[i][0], x, y);
                    }

                }
                //中心绘制文字
                Those.ctx.font="bold 36px 微软雅黑";
                Those.ctx.fillStyle='#6795f7';
                Those.ctx.fillText("100",Those.mCenter-18,Those.mCenter+16);
                Those.ctx.restore();
            },
            //绘制数据区域
            drawRegion(){
                let Those = this;
                Those.ctx.save();
                Those.ctx.beginPath();
                for(let i = 0; i < Those.mCount; i ++){
                    let x = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * i) * Those.radarData[i][1] / 100;
                    let y = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * i) * Those.radarData[i][1] / 100;
                    Those.ctx.lineTo(x, y);
                }
                Those.ctx.closePath();
                Those.ctx.fillStyle = 'rgba(255, 0, 0, 0.2)';
                Those.ctx.fill();
                Those.ctx.restore();
            },
            //画点
            drawCircle(){
                let Those = this;
                Those.ctx.save();
                let r = Those.mCenter / 50;
                for(let i = 0; i < Those.mCount; i ++){
                    let x = Those.mCenter + Those.mRadius * Math.cos(Those.mAngle * i) * Those.radarData[i][1] / 100;
                    let y = Those.mCenter + Those.mRadius * Math.sin(Those.mAngle * i) * Those.radarData[i][1] / 100;
                    Those.ctx.beginPath();
                    Those.ctx.arc(x, y, r, 0, Math.PI * 2);
                    Those.ctx.fillStyle = '#6795f7';
                    Those.ctx.fill();
                }
                 Those.ctx.restore();
            }
        }
    }
</script>

<style scoped>
    .content{
        background: #fff;
    }
    #Radar{
        display: block;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/module/canvasRadar/canvasRadar.vue